module.exports = __webpack_public_path__ + "ipetbooking-landing/img/section6-image.f7f8dd67.svg";